"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.layoutText = exports.wrapText = void 0;
var alignment_1 = require("../alignment");
var derive_font_metrics_1 = require("../derive-font-metrics");
var FONT_SIZE_REDUCTION = 0.5;
var appendWord = function (text, word) {
    return text ? "".concat(text, " ").concat(word) : word;
};
var wrapText = function (_a) {
    var text = _a.text, width = _a.width, measureTextWidth = _a.measureTextWidth;
    var createLine = function (text) { return ({
        text: text,
        width: measureTextWidth(text),
    }); };
    var paragraphsText = text.trim().split('\n');
    return paragraphsText.map(function (paragraphText) {
        var e_1, _a;
        var lines = [];
        var words = paragraphText.split(' ');
        var currentLine = createLine('');
        try {
            for (var words_1 = __values(words), words_1_1 = words_1.next(); !words_1_1.done; words_1_1 = words_1.next()) {
                var word = words_1_1.value;
                var line = createLine(appendWord(currentLine.text, word));
                if (line.width > width) {
                    lines.push(currentLine);
                    currentLine = createLine(word);
                }
                else {
                    currentLine = line;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (words_1_1 && !words_1_1.done && (_a = words_1.return)) _a.call(words_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        lines.push(currentLine);
        return lines;
    });
};
exports.wrapText = wrapText;
var getMaxFontSizeForLongestWord = function (options) {
    var e_2, _a;
    var maxFontSize = options.fontSize;
    var words = options.text.split(/\s/);
    try {
        for (var words_2 = __values(words), words_2_1 = words_2.next(); !words_2_1.done; words_2_1 = words_2.next()) {
            var word = words_2_1.value;
            while (maxFontSize > 0) {
                var wordWidth = options.measureTextWidth({
                    text: word,
                    fontSize: maxFontSize,
                });
                if (wordWidth <= options.width) {
                    break;
                }
                maxFontSize -= FONT_SIZE_REDUCTION;
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (words_2_1 && !words_2_1.done && (_a = words_2.return)) _a.call(words_2);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return maxFontSize;
};
var getMaxFontSizeForTextHeight = function (options) {
    var fontSize = options.fontSize;
    var lineHeight = 0;
    var lineOffsetY = 0;
    var paragraphs = [];
    while (fontSize > 0) {
        paragraphs = (0, exports.wrapText)({
            text: options.text,
            width: options.width,
            measureTextWidth: function (text) { return options.measureTextWidth({ text: text, fontSize: fontSize }); },
        });
        lineHeight = options.measureTextHeight({
            fontSize: fontSize,
            intrinsic: options.intrinsic,
        });
        lineOffsetY = (0, derive_font_metrics_1.deriveLineOffset)({
            fontMetrics: options.fontData.fontMetrics,
            lineHeight: lineHeight,
        });
        var lineCount = paragraphs.reduce(function (acc, paragraph) { return acc + paragraph.length; }, 0);
        var textHeight = lineCount * lineHeight;
        if (textHeight <= options.height) {
            break;
        }
        fontSize -= FONT_SIZE_REDUCTION;
    }
    return {
        fontSize: fontSize,
        lineHeight: lineHeight,
        lineOffsetY: lineOffsetY,
        paragraphs: paragraphs,
    };
};
var layoutText = function (options) {
    var intrinsic = options.lineSpacing <= 0 ||
        Math.abs(options.lineSpacing - options.maxFontSize) <= 1;
    var _a = getMaxFontSizeForTextHeight({
        text: options.text,
        height: options.height,
        width: options.width,
        fontData: options.fontData,
        intrinsic: intrinsic,
        measureTextWidth: options.measureTextWidth,
        measureTextHeight: options.measureTextHeight,
        fontSize: getMaxFontSizeForLongestWord({
            fontSize: options.maxFontSize,
            text: options.text,
            width: options.width,
            measureTextWidth: options.measureTextWidth,
        }),
    }), lineHeight = _a.lineHeight, paragraphs = _a.paragraphs, fontSize = _a.fontSize, lineOffsetY = _a.lineOffsetY;
    var maxFontSize = getMaxFontSizeForTextHeight({
        text: options.text,
        height: options.height,
        width: options.width,
        fontData: options.fontData,
        intrinsic: intrinsic,
        measureTextWidth: options.measureTextWidth,
        measureTextHeight: options.measureTextHeight,
        fontSize: getMaxFontSizeForLongestWord({
            fontSize: 100,
            text: options.text,
            width: options.width,
            measureTextWidth: options.measureTextWidth,
        }),
    }).fontSize;
    var fragments = (0, alignment_1.alignParagraphs)({
        paragraphs: paragraphs,
        lineHeight: lineHeight,
        width: options.width,
        height: options.height,
        horizontalAlignment: options.horizontalAlignment,
        verticalAlignment: options.verticalAlignment,
        measureTextWidth: function (text) { return options.measureTextWidth({ text: text, fontSize: fontSize }); },
    });
    return {
        fragments: fragments,
        fontSize: fontSize,
        maxFontSize: maxFontSize,
        lineHeight: lineHeight,
        lineOffsetY: lineOffsetY,
    };
};
exports.layoutText = layoutText;
